export const FAVOURITE_VIALMA_PLAYLISTS_CACHE_KEY = "favouriteVialmaPlaylists";
export const FAVOURITE_VIDEOS_CACHE_KEY = "favouriteVideos";
export const FAVOURITE_COLLECTIONS_CACHE_KEY = "favouriteCollections";
export const FAVOURITE_ALBUMS_CACHE_KEY = "favouriteAlbums";
export const FAVOURITE_TRACKS_CACHE_KEY = "favouriteTracks";